export default __webpack_public_path__ + "static/media/Yenepoya-Photos-1.55a03254.png";